import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isLinkPreviewOptionDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled !== state.userOptions.LinkPreviewEnabled);
});
//# sourceMappingURL=isLinkPreviewOptionDirty.js.map